/**
 * How many cover frames each game has in public/games/covers/.
 *
 * GENERATED by scripts/shoot-game-covers.mjs — do not edit by hand; re-run
 * the script after changing a game. A game missing here keeps its drawn cover.
 */
export const COVER_FRAMES: Record<string, number> = {
  2048: 3,
  bakery: 3,
  balloons: 3,
  barrage: 3,
  beastkingdom: 3,
  blockfall: 2,
  bombsquad: 3,
  bounty: 3,
  brawler: 3,
  breaker: 3,
  bubble: 3,
  bubblewar: 3,
  castle: 3,
  coinrun: 3,
  commando: 3,
  contra: 3,
  crates: 3,
  crest: 3,
  defender: 3,
  depths: 3,
  drift: 3,
  echo: 3,
  emberkeep: 3,
  flow: 3,
  fourinarow: 3,
  fruit: 3,
  gems: 3,
  hop: 3,
  ironline: 3,
  ironlinecrypto: 3,
  jeep: 3,
  mandate: 3,
  maze: 3,
  memory: 3,
  minesweeper: 3,
  moles: 3,
  nebula: 3,
  neonrun: 3,
  paddle: 3,
  potter: 3,
  prank: 3,
  prism: 3,
  pulse: 3,
  rivercross: 3,
  sheepwar: 3,
  skyclimb: 3,
  snake: 3,
  sneakypranks: 3,
  solitaire: 3,
  splat: 3,
  stack: 3,
  sudoku: 3,
  swarm: 3,
  swarmcrypto: 3,
  tanks: 3,
  tictactoe: 3,
  turbo: 3,
  vf2: 3,
  vortex: 3,
  xiaoxiao: 3,
};
